import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { OrderModel } from './model/order.model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SystemSettingService } from 'src/app/common/services/system-setting.service';

import { OrderService } from './order.service';
import { EmailDialogComponent } from './dialogs/email-dialog/email-dialog.component';
@Component({
  selector: 'app-order',
  standalone: false,

  templateUrl: './order.component.html',
  styleUrl: './order.component.scss'
})
export class OrderComponent {



  orderList: OrderModel[] = [];

  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [
    {
      title: "Order Id",
      column: "order_hdrs.order_id",
    },
    {
      title: "Station Code",
      column: "station_code",
    },
    {
      title: "User",
      column: "users.name",
    },
    {
      title: "Order Time",
      column: "closing_time",
      type: "date",
    },
    {
      title: "POS Date",
      column: "closing_date",
      type: "date",
    },
    {
      title: "Customer Name",
      column: "CONCAT_WS('',order_customer.first_name, ' ', order_customer.last_name )",
    },
    {
      title: "Total Amount",
      column: "total_amount_paid",
      type: "number",
      operators: [
        { title: "is", operator: "=" },
        { title: ">", operator: ">=" },
        { title: "<", operator: "<=" },

      ],
    },

  ];
  displayedColumns = ['order_id', 'station_code', 'user_name', 'closing_time', 'closing_date', 'customer', 'status', 'total_amount_paid', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: OrderModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<OrderModel>(true, []);
  dataSource = new MatTableDataSource(this.orderList);
  IsDownloading: boolean = false;
  dateFormat: string;
  constructor(private breakpointObserver: BreakpointObserver,
    private orderService: OrderService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private router: Router, private stateManagerService: StateManagerService,
    private systemSettingService: SystemSettingService,

  ) {

    this.orderList = [];
    this.dateFormat = systemSettingService.getDefaultDateFormat();

  }

  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.isLoading = false; // Set to true on page load
    //this.loadData();
  }
  /** 
   * Set the datasource
   */
  setDataSource(orderList: OrderModel[]) {
    this.dataSource = new MatTableDataSource(orderList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('closing_date', 'desc');
      this.loadData();
    }

  }
  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    this.sort.sort({
      id: column,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.orderList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.orderList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }


  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.orderService.getOrderList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.setDataSource(response.data.orders);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.onRowSelected(this.orderList[0])
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }
  openEmailDialog() {
    // Check if an order is selected
    if (!this.selectedItem) {
      let snackBarData: SnackBarData = {
        message: 'Please select an order first',
        title: 'No Order Selected',
        type: 'warn'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }
    // Open the Mat Dialog for sending email
    const dialogRef = this.dialog.open(EmailDialogComponent, {
      width: "400px",
      data: {
        order_id: this.selectedItem.order_id,
        total_amount_paid: this.selectedItem.total_amount_paid,
        email: this.selectedItem.email // Assuming email is a property of OrderModel
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Handle the result from dialog if needed
      if (result) {
        // Do something with the result, e.g., show a success message
        let snackBarData: SnackBarData = {
          message: 'Email sent successfully',
          title: 'Success',
          type: 'success'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
  * On orderInfo selected
  * @param orderInfo 
  */
  onRowSelected(orderInfo: OrderModel): void {
    this.selectedItem = orderInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }




  /**     
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On View clicked
   */
  onRedirect(orderInfo: OrderModel): void {
    // Replace 'customer_id_value' with the actual customer ID you want to pass
    const orderId = orderInfo.order_id;
    this.router.navigate(['report/order-summary', orderId]);

  }



}

